<template>
  <el-dialog :visible.sync="visible"
             title="编辑">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item prop="name" label="姓名">
        <el-input v-model="dataForm.name" placeholder="姓名" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item prop="code" label="员工编号">
        <el-input v-model="dataForm.code" placeholder="员工编号" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item prop="email" label="邮箱">
        <el-input v-model="dataForm.email" placeholder="邮箱" :maxlength="100"></el-input>
      </el-form-item>
      <el-form-item prop="orgId" label="部门">
        <el-popover v-model="deptListVisible" ref="deptListPopover" placement="bottom-start" trigger="click">
          <el-tree
            :data="orgTree"
            :props="{ label: 'orgName', children: 'children' }"
            node-key="orgId"
            ref="deptListTree"
            :highlight-current="true"
            :expand-on-click-node="false"
            accordion
            @current-change="deptListTreeCurrentChangeHandle">
          </el-tree>
        </el-popover>
        <el-input v-model="dataForm.orgName" v-popover:deptListPopover :readonly="true" placeholder="选择所属部门">
          <i
            v-if="$store.state.user.superAdmin === 1 && dataForm.pid !== '0'"
            slot="suffix"
            @click.stop="deptListTreeSetDefaultHandle()"
            class="el-icon-circle-close el-input__icon">
          </i>
        </el-input>
        <!-- <el-input v-model="dataForm.orgId" placeholder="部门" :maxlength="20"></el-input> -->
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dataFormSubmitHandle()">确 定</el-button>
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'
import { isEmail } from '@/utils/validate'
export default {
  data () {
    return {
      visible: false,
      orgTree: [],
      dataForm: {
        userId: '',
        name: '',
        email: '',
        orgId: '',
        orgName: '',
        postId: '',
        code: '',
        mobile: '',
        status: true,
        custId: ''
      },
      deptListVisible: false
    }
  },
  computed: {
    dataRule () {
      var validateEmail = (rule, value, callback) => {
        if (!isEmail(value)) {
          return callback(new Error(this.$t('validate.format', { 'attr': this.$t('user.email') })))
        }
        callback()
      }
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        orgId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.dataForm.userId = ''
        this.dataForm.name = ''
        this.dataForm.email = ''
        this.dataForm.orgId = ''
        this.dataForm.orgName = ''
        this.dataForm.postId = ''
        this.dataForm.code = ''
        this.dataForm.mobile = ''
        this.dataForm.status = true
        if (this.dataForm.custId) {
          this.getInfo()
        }
      })
    },
    // 上级部门树, 选中
    deptListTreeCurrentChangeHandle (data) {
      this.dataForm.orgId = data.orgId
      this.dataForm.orgName = data.orgName
      this.deptListVisible = false
    },
    getInfo () {
      this.$request.get(`/front/consumer/custorg/sysUserInfo/${this.dataForm.custId}`)
        .then((res) => {
          this.dataForm.name = res.name
          this.dataForm.email = res.email
          this.dataForm.orgId = res.orgId
          this.dataForm.orgName = res.orgName
          this.dataForm.postId = res.postId
          this.dataForm.code = res.code
          this.dataForm.mobile = res.mobile
          this.dataForm.status = res.status
          this.dataForm.custId = res.custId
          this.dataForm.userId = res.userId
        }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post(`/front/consumer/custorg/updateCompanyUser`, this.dataForm)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
              // this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang='scss' scoped>
</style>
